import fetch from '../../utils/fetch';
import { getUserToken } from '../../utils/helpers';
import { API_ROUTES } from '../../utils/constants';

export const getCountriesAPI = () => {
  const accessToken = getUserToken().access_token;
  const headers = {
    'Content-Type': 'multipart/form-data',
    Authorization: `Bearer ${accessToken}`,
  };

  return fetch({
    method: 'GET', route: API_ROUTES.COUNTRIES, requestHeaders: headers, basic: false,
  });
};

export const getRegionsAPI = (CountryId) => {
  const accessToken = getUserToken().access_token;
  const headers = {
    'Content-Type': 'multipart/form-data',
    Authorization: `Bearer ${accessToken}`,
  };
  const paramsApi = {
    CountryId,
  };
  return fetch({
    method: 'GET', route: API_ROUTES.REGIONS, requestHeaders: headers, basic: false, params: paramsApi,
  });
};

export const getCompanyMedias = (companyId) => {
  const accessToken = getUserToken().access_token;
  const headers = {
    'Content-Type': 'multipart/form-data',
    Authorization: `Bearer ${accessToken}`,
  };
  return fetch({
    method: 'GET', route: `${API_ROUTES.CAMPAIGN}/${companyId}/media`, requestHeaders: headers, basic: false,
  });
};

export const getCitiesAPI = (RegionId) => {
  const accessToken = getUserToken().access_token;
  const headers = {
    'Content-Type': 'multipart/form-data',
    Authorization: `Bearer ${accessToken}`,
  };
  const paramsApi = {
    RegionId,
  };
  return fetch({
    method: 'GET', route: API_ROUTES.CITIES, requestHeaders: headers, basic: false, params: paramsApi,
  });
};

export const createCampaignAPI = (data) => {
  const accessToken = getUserToken().access_token;
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${accessToken}`,
  };
  const formData = JSON.stringify(data);
  return fetch({
    method: 'POST', route: API_ROUTES.CAMPAIGN, data: formData, requestHeaders: headers, basic: false,
  });
};

export const getAppCampaignsAPI = ({ appId }) => {
  const accessToken = getUserToken().access_token;
  const headers = {
    Authorization: `Bearer ${accessToken}`,
  };
  return fetch({
    method: 'GET', route: `${API_ROUTES.CREATE_APP}/${appId}/campaign`, requestHeaders: headers, basic: false,
  });
};

export const patchCampaignAPI = (data) => {
  const dataSize = data;
  const accessToken = getUserToken().access_token;
  const headers = {
    Authorization: `Bearer ${accessToken}`,
    'Content-Type': 'application/json',
  };
  const { campaignId } = data;
  switch (dataSize.field) {
    case 'dailyBudget': {
      const formData = {
        dailyBudget: [{
          platform: dataSize.platform,
          value: dataSize.value,
        }],
      };
      return fetch({
        method: 'PATCH', route: `${API_ROUTES.CAMPAIGN}/${campaignId}`, data: JSON.stringify(formData), requestHeaders: headers, basic: false,
      });
    }
    case 'cpi': {
      const formData = {
        cpiList: [{
          platform: dataSize.platform,
          value: dataSize.value,
        }],
      };
      return fetch({
        method: 'PATCH', route: `${API_ROUTES.CAMPAIGN}/${campaignId}`, data: JSON.stringify(formData), requestHeaders: headers, basic: false,
      });
    }
    case 'fee': {
      const formData = {
        platform: dataSize.platform,
        value: dataSize.value,
      };
      const feeList = [formData];
      return fetch({
        method: 'PATCH', route: `${API_ROUTES.CAMPAIGN}/${campaignId}`, data: { feeList }, requestHeaders: headers, basic: false,
      });
    }
    case 'status': {
      const formData = {
        status: dataSize.value,
      };
      return fetch({
        method: 'PATCH', route: `${API_ROUTES.CAMPAIGN}/${campaignId}`, data: JSON.stringify(formData), requestHeaders: headers, basic: false,
      });
    }
    case 'cpiBid': {
      const formData = {
        platform: 'cpi',
        value: dataSize.value,
      };
      const cpiBid = [formData];
      return fetch({
        method: 'PATCH', route: `${API_ROUTES.CAMPAIGN}/${campaignId}`, data: { cpiBid }, requestHeaders: headers, basic: false,
      });
    }
    default: {
      const formData = {
        adPlatforms: data.adPlatforms,
        cpiList: data.cpi,
        dailyBudget: data.dailyBudget,
        feeList: data.feeList,
        locations: data.locations,
        name: data.name,
        status: data.status,
        targetAction: data.targetAction,
        targetSex: data.targetSex,
        targetAge: data.targetAge,
      };
      if (data.platform) {
        formData.platform = data.platform;
      }
      return fetch({
        method: 'PATCH', route: `${API_ROUTES.CAMPAIGN}/${campaignId}`, data: JSON.stringify(formData), requestHeaders: headers, basic: false,
      });
    }
  }
};

export const attachMediaAPI = (data) => {
  const accessToken = getUserToken().access_token;
  const headers = {
    Authorization: `Bearer ${accessToken}`,
    'Content-Type': 'application/json',
  };
  const { campaignId, media } = data;
  return fetch({
    method: 'POST', route: `${API_ROUTES.CAMPAIGN}/${campaignId}/media`, data: JSON.stringify(media), requestHeaders: headers, basic: false,
  });
};

export const getCampaignAPI = (data) => {
  const accessToken = getUserToken().access_token;
  const headers = {
    Authorization: `Bearer ${accessToken}`,
    'Content-Type': 'application/json',
  };
  const { campaignId } = data;
  return fetch({
    method: 'GET', route: `${API_ROUTES.CAMPAIGN}/${campaignId}`, requestHeaders: headers, basic: false,
  });
};

export const updateCampaignAPI = (data) => {
  const accessToken = getUserToken().access_token;
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${accessToken}`,
  };

  const { campaignId } = data;
  const newData = { ...data };
  delete newData.campaignId;
  const formData = JSON.stringify(newData);
  return fetch({
    method: 'PUT', route: `${API_ROUTES.CAMPAIGN}/${campaignId}`, data: formData, requestHeaders: headers, basic: false,
  });
};



// WEBPACK FOOTER //
// ./src/reducers/create-campaign/api.js